{
  "optimizationInputsForm": {
    "sections": {
      "initialDimensions": "Dimensions initiales",
      "variations": "Variantes",
      "sizesToTest": "Tailles à tester",
      "aircraftMix": "Flotte d'aéronefs"
    },
    "labels": {
      "width": "Largeur ({{unit}})",
      "depth": "Profondeur ({{unit}})",
      "widthVariation": "+/- largeur ({{unit}})",
      "depthVariation": "+/- profondeur ({{unit}})",
      "searchAircraft": "Rechercher par marque et modèle",
      "numberAircraft": "# Aéronefs",
      "configurations": "configurations"
    },
    "tableHeaders": {
      "make": "Créer",
      "model": "Modèle",
      "wingspan": "Envergure ({{unit}})",
      "length": "Longueur ({{unit}})",
      "tailHeight": "Hauteur de queue ({{unit}})"
    }
  },
  "optimizationHangarResults": {
    "buttons": {
      "stop": "Stop",
      "run": "Go"
    },
    "tableHeaders": {
      "hangar": "Hangar",
      "doors": "Portes",
      "progress": "Progression",
      "numberInHangar": "En hangar",
      "utilization": "Utilisation",
      "worst": "Pire",
      "best": "Cdt",
      "average": "Moyenne"
    }
  }
}
